import { ServerApiError } from '@wellesley/openapi/helpers'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

const isInvalidCredsError = (error: FetchBaseQueryError) => {
  return (
    error?.status === 401 &&
    (error?.data as ServerApiError)?.errorCode === 'UserBadCreds'
  )
}

export default isInvalidCredsError
